export default __webpack_public_path__ + "static/media/hi.eec981db.jpg";